<template>
  <HgButton
    v-bind="$attrs"
    :disabled="disabled"
    :icon="icon"
    :iconPosition="iconPosition"
    :iconSize="iconSize"
    :size="size"
    :tag="tag"
    :theme="theme"
    :themeClass="themeClass"
    @click.exact="emitClick"
    @click.meta="handleClick"
    @click.ctrl="handleClick"
    @click.shift="handleClick"
    @auxclick="handleAuxClick"
    @contextmenu="handleContextMenu"
    @touchstart.passive="touchStartHandler"
    @touchend.passive="touchEndHandler"
    @touchmove.passive="touchMoveHandler"
    @touchcancel.passive="touchCancelHandler"
  >
    <template v-if="$slots.icon" #icon="slotProps">
      <slot name="icon" v-bind="slotProps"></slot>
    </template>
    <template #default="slotProps">
      <slot v-bind="slotProps"></slot>
    </template>
  </HgButton>
</template>

<script lang="ts" setup>
import { HgButton } from '@smg-real-estate/domus';

import { type NewTabIntentEvent, useDetectNewTabIntent } from '@/composables/useDetectNewTabIntent';

defineOptions({
  name: 'PartnerTrackedLink',
  inheritAttrs: false,
});

type HgButtonProps = InstanceType<typeof HgButton>['$props'];

interface Props {
  disabled?: HgButtonProps['disabled'];
  icon?: HgButtonProps['icon'];
  iconPosition?: HgButtonProps['iconPosition'];
  iconSize?: HgButtonProps['iconSize'];
  size?: HgButtonProps['size'];
  tag?: HgButtonProps['tag'];
  theme?: HgButtonProps['theme'];
  themeClass?: HgButtonProps['themeClass'];
}

withDefaults(defineProps<Props>(), {
  disabled: false,
  icon: undefined,
  iconPosition: 'left',
  iconSize: 'medium',
  size: 'default',
  tag: 'a',
  theme: 'primary',
  themeClass: undefined,
});

const emit = defineEmits<{
  click: [event: NewTabIntentEvent];
}>();

const emitClick = (event: NewTabIntentEvent): void => {
  emit('click', event);
};

const {
  handleClick,
  handleAuxClick,
  handleContextMenu,
  touchStartHandler,
  touchEndHandler,
  touchMoveHandler,
  touchCancelHandler,
} = useDetectNewTabIntent(emitClick);
</script>
